import DataStream from './DataStream';

export default DataStream;
